import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Analytics Provider Component
 * Initializes GA4 and tracks page views on route changes
 */
const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  // Initialize GA4 on mount
  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      // Small delay to ensure page title is updated
      const timer = setTimeout(() => {
        trackPageView(location.pathname, document.title);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return children;
};

export default AnalyticsProvider;
